// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

import { statusMapper } from '../common'

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av
    let bv

    switch (col) {
      case 'frequencyRange' :
        av = a.loFrequency
        bv = b.loFrequency
        break

      case 'status' :
        av = statusMapper(a[col])
        bv = statusMapper(b[col])
        break

      // when sorting by this column, we need to consider ACM radios.
      // if it is an ACM radio, then there will be more than one modulation.
      // as such, we will treat this value as null and place it at the bottom of the order
      // for non-ACM radios, we simply sort on the throughput of the single modulation.
      case 'modulations' :
        av = a[col].length === 1 ? a[col][0].throughput : 0
        bv = b[col].length === 1 ? b[col][0].throughput : 0
        break

      default :
        av = a[col].toString().toLowerCase()
        bv = b[col].toString().toLowerCase()
        break
    }

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

// based on form's values, determine which column to sort by.
export const getSortColByFormValues = (formValues) => {
  let col
  // only sorts by Radio code on search submit.
  // no reqs were defined like the other lookups
  // for sorting based on for values.
  col = 'radioCode'
  return col
}
